






import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { Size, TextStyle } from "../../domain/drawing";

@Component({
})
export default class TextSizeMeasure extends Mixins() {
  measure(text: string, textStyle: TextStyle): Size {
    const texts = text.split(/[\r\n]+/);
    const element = this.$refs.element as HTMLCanvasElement;
    const ctx = element.getContext("2d");
    ctx.font = textStyle.displayFontSize + "px '" + textStyle.fontFamily + "'";
    return new Size(
      Math.ceil(Enumerable.from(texts).max((t) => ctx.measureText(t).width)),
      Math.ceil(texts.length * textStyle.displayFontSize * textStyle.lineHeight));
  }
}
